import {Box, Text, Title} from '@mantine/core';
import Head from 'next/head';
import {useRouter} from 'next/router';
import {MdPeopleAlt} from 'react-icons/md';
import {GSSKT_HOST} from '../../../config/constants/hosts';
import type {GetWebSeminarsEventsResponse} from '../../../core/repositories/webSeminarsRepository';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';
import {WebSeminarsContainer} from './WebSeminarsContainer';
import {WebSeminarsHeader} from './WebSeminarsHeader';

type Props = {
  webSeminarsEvents?: GetWebSeminarsEventsResponse;
  isStudentVerificationRequired: boolean;
};

export const WebSeminarsPage: React.FC<Props> = ({
  webSeminarsEvents,
  isStudentVerificationRequired,
}) => {
  const router = useRouter();
  const TITLE = 'Web合説 企業動画一覧 | 外資就活ドットコム';
  const currentUrl = `${GSSKT_HOST}${decodeURI(router.asPath)}`;
  const {isPC} = useMediaQuery();

  return (
    <>
      <Head>
        <title key="title">{TITLE}</title>
        <meta key="og:title" property="og:title" content={TITLE} />
        <meta key="og:url" property="og:url" content={currentUrl} />
        <link rel="canonical" href={currentUrl} key="canonical" />
      </Head>

      <Box className="w-full pc:max-w-[70%] mb-[10px] ">
        <Title
          order={1}
          className="mb-sy border-t-4 border-primary-1 bg-white p-16 text-lg text-primary-1 pc:px-32 flex items-center"
        >
          <MdPeopleAlt className="text-xl mr-2" color="currentColor" />
          <span className="mr-24">Web合説</span>
          {isPC && (
            <Text className="text-black-2 text-sm ml-24">
              動画でわかる企業とキャリア
            </Text>
          )}
        </Title>
      </Box>
      <WebSeminarsHeader />
      <WebSeminarsContainer
        webSeminarsEvents={webSeminarsEvents}
        isStudentVerificationRequired={isStudentVerificationRequired}
      />
    </>
  );
};
